module.exports = __webpack_public_path__ + "media/images/hexa2-a8ec1a73213bc0e1d7c684bbf96f652a.png";